export default __webpack_public_path__ + "static/avatar-02-ae336a0e0b0b137add081f2afb7c5476.svg";